import { nanoid } from "@otto-ec/global-resources/misc";

/**
 *
 */
export function useTabInitialization(): {
  initializeTabs: (tabs: HTMLElement[], panels: HTMLElement[]) => void;
  initializePanels: (panels: HTMLElement[], tabs: HTMLElement[]) => void;
} {
  function initializeTabs(tabs: HTMLElement[], panels: HTMLElement[]): void {
    tabs.forEach((tab, index) => {
      if (!tab.id) {
        tab.id = `oc-tab-${nanoid()}`;
      }

      tab.setAttribute("data-index", String(index));

      /*                                                               */
      const interactiveElement = tab.querySelector("button, a");
      if (interactiveElement && panels[index]) {
        interactiveElement.setAttribute("aria-controls", panels[index].id);
      }
    });
  }

  function initializePanels(panels: HTMLElement[], tabs: HTMLElement[]): void {
    panels.forEach((panel, index) => {
      if (!panel.id) {
        panel.id = `oc-panel-${nanoid()}`;
      }

      if (tabs[index]) {
        panel.setAttribute("aria-labelledby", tabs[index].id);
      }
    });
  }

  return {
    initializeTabs,
    initializePanels,
  };
}
